import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowPathUp: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconArrowPathUp"><Path d="M4.69986 9.4C4.20544 10.0592 4.67582 11 5.49986 11H7.99986V19.5C7.99986 20.8807 9.11915 22 10.4999 22H13.4999C14.8806 22 15.9999 20.8807 15.9999 19.5V11H18.4999C19.3239 11 19.7943 10.0592 19.2999 9.4L13.5999 1.8C12.7999 0.733333 11.1999 0.733333 10.3999 1.8L4.69986 9.4Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowPathUp;
